var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [_c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('form-wizard', {
    staticClass: "wizard-vertical mb-3",
    attrs: {
      "color": "#ff9801",
      "title": null,
      "subtitle": null,
      "finish-button-text": _vm.$t('Simpan'),
      "back-button-text": "Sebelumnya",
      "next-button-text": "Selanjutnya"
    },
    on: {
      "on-complete": _vm.formSubmitted
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Pengirim",
      "before-change": _vm.validationForm
    }
  }, [_c('validation-observer', {
    ref: "form"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nama Pengirim",
      "label-for": "v-sender_name"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "sender_name",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-sender_name",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Nama Pengirim"
          },
          model: {
            value: _vm.form.sender_name,
            callback: function ($$v) {
              _vm.$set(_vm.form, "sender_name", $$v);
            },
            expression: "form.sender_name"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Alamat Pengirim",
      "label-for": "v-sender_address"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "sender_address",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var errors = _ref2.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-sender_address",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Alamat Pengirim"
          },
          model: {
            value: _vm.form.sender_address,
            callback: function ($$v) {
              _vm.$set(_vm.form, "sender_address", $$v);
            },
            expression: "form.sender_address"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Telepon Pengirim",
      "label-for": "v-sender_phone"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "sender_phone",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var errors = _ref3.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-sender_phone",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Telepon Pengirim"
          },
          model: {
            value: _vm.form.sender_phone,
            callback: function ($$v) {
              _vm.$set(_vm.form, "sender_phone", $$v);
            },
            expression: "form.sender_phone"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Email Pengirim",
      "label-for": "v-sender_email"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "sender_email",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref4) {
        var errors = _ref4.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-sender_email",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Email Pengirim"
          },
          model: {
            value: _vm.form.sender_email,
            callback: function ($$v) {
              _vm.$set(_vm.form, "sender_email", $$v);
            },
            expression: "form.sender_email"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Latitude Pengirim",
      "label-for": "v-sender_latitude"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "sender_latitude",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref5) {
        var errors = _ref5.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-sender_latitude",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Latitude Pengirim"
          },
          model: {
            value: _vm.form.sender_latitude,
            callback: function ($$v) {
              _vm.$set(_vm.form, "sender_latitude", $$v);
            },
            expression: "form.sender_latitude"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Longitude Pengirim",
      "label-for": "v-sender_longitude"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "sender_longitude",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref6) {
        var errors = _ref6.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-sender_longitude",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Longitude Pengirim"
          },
          model: {
            value: _vm.form.sender_longitude,
            callback: function ($$v) {
              _vm.$set(_vm.form, "sender_longitude", $$v);
            },
            expression: "form.sender_longitude"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Penerima"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nama Penerima",
      "label-for": "v-recipient_name"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "recipient_name",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref7) {
        var errors = _ref7.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-recipient_name",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Nama Penerima"
          },
          model: {
            value: _vm.form.recipient_name,
            callback: function ($$v) {
              _vm.$set(_vm.form, "recipient_name", $$v);
            },
            expression: "form.recipient_name"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Alamat Penerima",
      "label-for": "v-recipient_address"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "recipient_address",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref8) {
        var errors = _ref8.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-recipient_address",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Alamat Penerima"
          },
          model: {
            value: _vm.form.recipient_address,
            callback: function ($$v) {
              _vm.$set(_vm.form, "recipient_address", $$v);
            },
            expression: "form.recipient_address"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Telepon Penerima",
      "label-for": "v-recipient_phone"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "recipient_phone",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref9) {
        var errors = _ref9.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-recipient_phone",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Telepon Penerima"
          },
          model: {
            value: _vm.form.recipient_phone,
            callback: function ($$v) {
              _vm.$set(_vm.form, "recipient_phone", $$v);
            },
            expression: "form.recipient_phone"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Email Penerima",
      "label-for": "v-recipient_email"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "recipient_email",
      "rules": "required|email"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref10) {
        var errors = _ref10.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-recipient_email",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Email Penerima"
          },
          model: {
            value: _vm.form.recipient_email,
            callback: function ($$v) {
              _vm.$set(_vm.form, "recipient_email", $$v);
            },
            expression: "form.recipient_email"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Latitude Penerima",
      "label-for": "v-recipient_latitude"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "recipient_latitude",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref11) {
        var errors = _ref11.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-recipient_latitude",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Latitude Penerima"
          },
          model: {
            value: _vm.form.recipient_latitude,
            callback: function ($$v) {
              _vm.$set(_vm.form, "recipient_latitude", $$v);
            },
            expression: "form.recipient_latitude"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Longitude Penerima",
      "label-for": "v-recipient_longitude"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "recipient_longitude",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref12) {
        var errors = _ref12.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-recipient_longitude",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Longitude Penerima"
          },
          model: {
            value: _vm.form.recipient_longitude,
            callback: function ($$v) {
              _vm.$set(_vm.form, "recipient_longitude", $$v);
            },
            expression: "form.recipient_longitude"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Detail Pengiriman"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Layanan Pengiriman",
      "label-for": "v-delivery_service"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "delivery_service",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref13) {
        var errors = _ref13.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-delivery_service",
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.form.delivery_service,
            callback: function ($$v) {
              _vm.$set(_vm.form, "delivery_service", $$v);
            },
            expression: "form.delivery_service"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Tanggal Pengiriman",
      "label-for": "v-delivery_date"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "delivery_date",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref14) {
        var errors = _ref14.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-delivery_date",
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.form.delivery_date,
            callback: function ($$v) {
              _vm.$set(_vm.form, "delivery_date", $$v);
            },
            expression: "form.delivery_date"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Estimasi Pengiriman",
      "label-for": "v-delivery_estimation"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "delivery_estimation",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref15) {
        var errors = _ref15.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-delivery_estimation",
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.form.delivery_estimation,
            callback: function ($$v) {
              _vm.$set(_vm.form, "delivery_estimation", $$v);
            },
            expression: "form.delivery_estimation"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Biaya Pengiriman",
      "label-for": "v-delivery_cost"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "delivery_cost",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref16) {
        var errors = _ref16.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-delivery_cost",
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.form.delivery_cost,
            callback: function ($$v) {
              _vm.$set(_vm.form, "delivery_cost", $$v);
            },
            expression: "form.delivery_cost"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Instruksi Khusus",
      "label-for": "v-special_instructions"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "special_instructions",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref17) {
        var errors = _ref17.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-special_instructions",
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.form.special_instructions,
            callback: function ($$v) {
              _vm.$set(_vm.form, "special_instructions", $$v);
            },
            expression: "form.special_instructions"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Asuransi",
      "label-for": "v-insurance"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "insurance",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref18) {
        var errors = _ref18.errors;
        return [_c('b-form-checkbox', {
          attrs: {
            "id": "v-insurance",
            "switch": "",
            "inline": ""
          },
          model: {
            value: _vm.form.insurance,
            callback: function ($$v) {
              _vm.$set(_vm.form, "insurance", $$v);
            },
            expression: "form.insurance"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Kode Promo",
      "label-for": "v-promo_code"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "promo_code"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref19) {
        var errors = _ref19.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-promo_code",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Kode Promo"
          },
          model: {
            value: _vm.form.promo_code,
            callback: function ($$v) {
              _vm.$set(_vm.form, "promo_code", $$v);
            },
            expression: "form.promo_code"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Metode Pembayaran",
      "label-for": "v-payment_method"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "payment_method"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref20) {
        var errors = _ref20.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-payment_method",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi Metode Pembayaran"
          },
          model: {
            value: _vm.form.payment_method,
            callback: function ($$v) {
              _vm.$set(_vm.form, "payment_method", $$v);
            },
            expression: "form.payment_method"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Detail Barang"
    }
  }, [_vm.selectedItems.length <= 0 ? _c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "variant": "info"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.addList($event);
      }
    }
  }, [_vm._v(" Add Barang ")]) : _vm._e(), _c('b-table', {
    attrs: {
      "fields": _vm.tableFields,
      "items": _vm.selectedItems,
      "hover": "",
      "bordered": "",
      "striped": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function (_ref21) {
        var index = _ref21.index;
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "cell(description)",
      fn: function (_ref22) {
        var item = _ref22.item;
        return [_c('b-form-input', {
          model: {
            value: item.description,
            callback: function ($$v) {
              _vm.$set(item, "description", $$v);
            },
            expression: "item.description"
          }
        })];
      }
    }, {
      key: "cell(weight)",
      fn: function (_ref23) {
        var item = _ref23.item;
        return [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: item.weight,
            callback: function ($$v) {
              _vm.$set(item, "weight", $$v);
            },
            expression: "item.weight"
          }
        })];
      }
    }, {
      key: "cell(dimension)",
      fn: function (_ref24) {
        var item = _ref24.item;
        return [_c('b-form-input', {
          model: {
            value: item.dimension,
            callback: function ($$v) {
              _vm.$set(item, "dimension", $$v);
            },
            expression: "item.dimension"
          }
        })];
      }
    }, {
      key: "cell(quantity)",
      fn: function (_ref25) {
        var item = _ref25.item;
        return [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: item.quantity,
            callback: function ($$v) {
              _vm.$set(item, "quantity", $$v);
            },
            expression: "item.quantity"
          }
        })];
      }
    }, {
      key: "cell(value)",
      fn: function (_ref26) {
        var item = _ref26.item;
        return [_c('b-form-input', {
          on: {
            "keyup": function ($event) {
              return _vm.doFormatRupiah(item);
            }
          },
          model: {
            value: item.value,
            callback: function ($$v) {
              _vm.$set(item, "value", $$v);
            },
            expression: "item.value"
          }
        })];
      }
    }, {
      key: "cell(action)",
      fn: function (_ref27) {
        var index = _ref27.index,
          item = _ref27.item;
        return [index >= 0 ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.remove(index, item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "XIcon"
          }
        })], 1) : _vm._e()];
      }
    }])
  }), _vm.selectedItems.length > 0 ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.addList($event);
      }
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "PlusCircleIcon"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }